import {
  Box,
  IconButton,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadNotifications } from "../../common/actions";
import useDynamicConfig, { MANAGER } from "../../hooks/useDynamicConfig";
import { BellIcon } from "./Icons";
import NotificationsDrawer from "./NotificationsDrawer";

export const newNotificationsCircleStyle = {
  display: "block",
  position: "absolute",
  padding: "4px",
  top: "-7px",
  right: "-5px",
  backgroundColor: "brand.main",
  borderWidth: "4px",
  borderRadius: "8px",
  borderColor: "brand.mainLightest",
};

const NotificationBell = () => {
  const size = useBreakpointValue({ base: "full", md: "sm" });
  const btnRef = React.useRef();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const dynamicConfig = useDynamicConfig();
  const manager = dynamicConfig.get(MANAGER);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadNotifications(manager && manager.id));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { notifications } = useSelector((state) => state.notification);
  const newNotifications = (notifications || []).some((n) => !n.viewed);

  return (
    <>
      <IconButton
        variant="ghost"
        rounded={"100%"}
        ref={btnRef}
        onClick={onOpen}
        position="relative"
        icon={
          <Box>
            <Box
              {...newNotificationsCircleStyle}
              display={newNotifications ? "block" : "none"}
            />
            <BellIcon boxSize={"24px"} />
          </Box>
        }
      />
      <NotificationsDrawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        size={size}
        notifications={notifications}
      />
    </>
  );
};

export default NotificationBell;
